import DiffMatchPatch from "diff-match-patch";

const TOKEN_CHAR_START = 0xe000;
const TOKEN_CHAR_LIMIT = 0xf8ff;

function applyCleanup(dmp, diff, cleanUp, editCost) {
  if (cleanUp === "semantic") dmp.diff_cleanupSemantic(diff);
  if (cleanUp === "efficiency") {
    dmp.Diff_EditCost = editCost;
    dmp.diff_cleanupEfficiency(diff);
  }
}

function mergeAdjacentDiffs(diff) {
  const merged = [];
  diff.forEach(([operation, text]) => {
    if (!text) return;
    const previous = merged[merged.length - 1];
    if (previous && previous[0] === operation) {
      previous[1] += text;
      return;
    }
    merged.push([operation, text]);
  });
  return merged;
}

function tokenizeWords(text) {
  return text.match(/[\p{L}\p{N}]+(?:[-'’][\p{L}\p{N}]+)*|\s+|[^\s\p{L}\p{N}]/gu) || [];
}

function encodeTokens(tokens, tokenToChar, charToToken) {
  let didOverflow = false;
  const encoded = tokens
    .map((token) => {
      if (!tokenToChar.has(token)) {
        const nextCodePoint = TOKEN_CHAR_START + tokenToChar.size;
        if (nextCodePoint > TOKEN_CHAR_LIMIT) {
          didOverflow = true;
          return "";
        }
        const char = String.fromCharCode(nextCodePoint);
        tokenToChar.set(token, char);
        charToToken.set(char, token);
      }
      return tokenToChar.get(token);
    })
    .join("");
  return { encoded, didOverflow };
}

function buildWordDiffGroups(dmp, string1, string2, cleanUp, editCost) {
  const tokenToChar = new Map();
  const charToToken = new Map();
  const encoded1Result = encodeTokens(tokenizeWords(string1), tokenToChar, charToToken);
  const encoded2Result = encodeTokens(tokenizeWords(string2), tokenToChar, charToToken);

  if (encoded1Result.didOverflow || encoded2Result.didOverflow) {
    const fallbackDiff = dmp.diff_main(string1, string2);
    applyCleanup(dmp, fallbackDiff, cleanUp, editCost);
    return mergeAdjacentDiffs(fallbackDiff);
  }

  const diff = dmp.diff_main(encoded1Result.encoded, encoded2Result.encoded);
  applyCleanup(dmp, diff, cleanUp, editCost);
  return mergeAdjacentDiffs(
    diff.map(([operation, encodedText]) => [
      operation,
      Array.from(encodedText)
        .map((char) => charToToken.get(char) || "")
        .join(""),
    ]),
  );
}

export function buildDiffGroups(
  string1 = "",
  string2 = "",
  { cleanUp = "semantic", editCost = 4, diffUnit = "character" } = {},
) {
  const dmp = new DiffMatchPatch();

  if (diffUnit === "word") {
    return buildWordDiffGroups(dmp, string1, string2, cleanUp, editCost);
  }

  const diff = dmp.diff_main(string1, string2);
  applyCleanup(dmp, diff, cleanUp, editCost);
  return mergeAdjacentDiffs(diff);
}
